import Icon from '@/components/icon';
import { IconType } from '@/components/icon/helpers';
import Text from '@/components/text';
import { Stack, Theme } from '@mui/material';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  label: string;
  icon?: IconType;
  onClick: () => void;
}

const useStyles = createUseStyles((theme: Theme) => ({
  toolChip: {
    color: theme.palette.link.main,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
    '& .close-button': {
      marginTop: -2,
    },
  },
}));

const ToolChip: FC<Props> = ({ label, icon, onClick }) => {
  const styles = useStyles();
  const hasIcon = !!icon;

  return (
    <Stack
      className={styles.toolChip}
      direction="row"
      alignItems="center"
      justifyContent="flex-start"
      onClick={onClick}
      role="button"
      gap={0.5}
    >
      {hasIcon && <Icon name={icon} size="small" color="link" />}
      <Text size="x-small">{label}</Text>
      <Icon name="close" size="x-small" color="link" className="close-button" />
    </Stack>
  );
};

export default ToolChip;
